import { Storage } from '@wolfejs/core/utils/Storage';
import { isServer } from '@wolfejs/core/utils/environment';

export const localstore = isServer ? undefined : new Storage(window.localStorage);
export const sessionStore = isServer ? undefined : new Storage(window.sessionStorage);
